import { useParams, useSearchParams } from "react-router-dom";
import ShoppingCategoryService from "../../../services/ShoppingCategoryService";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCategoryEditForm from "./ui/shopping-category-edit-form";
import ShoppingCategorySkeleton from "./skeleton/shopping-category-skeleton";
import { ShoppingCategory } from "../../../models";

export default function ShoppingCategoryEditPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  const [shoppingCategory, setShoppingCategory] = useState<ShoppingCategory>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    const api = new ShoppingCategoryService();
    let active = true;

    async function fetchShoppingCategory() {
      try {
        const data = await api.getShoppingCategoryById(parseInt(id!));
        if (active) setShoppingCategory(data);
      } catch (error) {
        console.error("Error fetching shopping category:", error);
        if (active) setShoppingCategory(undefined);
      } finally {
        if (active) setLoading(false);
      }
    }

    fetchShoppingCategory();
    return () => {
      active = false;
    };
  }, [id, reload]);

  if (!shoppingCategory && !loading) return <NotFound message="Shopping category not found." />;

  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Categories", href: "/admin/shopping-category" },
          {
            label: "Edit",
            href: `/admin/shopping-category/edit/${id}`,
            active: true,
          },
        ]}
      />
      {!loading && shoppingCategory ? (
        <ShoppingCategoryEditForm shoppingCategory={shoppingCategory} />
      ) : (
        <ShoppingCategorySkeleton />
      )}
    </main>
  );
}
